import { type ReactNode } from "react";

const Tables = ({
  classNames,
  children,
}: {
  classNames: string;
  children: ReactNode;
}) => {
  return <table className={classNames}>{children}</table>;
};

export default Tables;